// Skidmore College's undergraduate majors (#2652, round 2). Read on
// 2026-10-01 from the official 2026-2027 Catalog's Degree Programs page
// (catalog.skidmore.edu/degree-programs/), which lists every program with its
// HEGIS code and program type in one list. Every Bachelor of Arts and
// Bachelor of Science line is kept; minors are left out. Mathematics B.A.
// carries no program type on the page but has the B.A. in its name. Left
// out: Business-Political Science B.A., which the catalog marks "Approved to
// be phased-out ... No longer accepting applications." The two engineering
// dual degree programs (with Dartmouth and Rensselaer) are listed by the
// catalog as Bachelor of Science programs and kept with a note.
const majors = {
    "slug": "skidmore-college",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Skidmore's official 2026-2027 Catalog, with the degree it leads to. The catalog lists its degree programs in one list, not by school. Minors and programs closed to new students are left out.",
    "groups": [
        {
            "name": "Degree programs",
            "source": {
                "label": "Skidmore 2026-2027 Catalog, Degree Programs",
                "url": "https://catalog.skidmore.edu/degree-programs/"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art (Studio)",
                    "degree": "B.S."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Business",
                    "degree": "B.S."
                },
                {
                    "name": "Business-French",
                    "degree": "B.A."
                },
                {
                    "name": "Business-German",
                    "degree": "B.A."
                },
                {
                    "name": "Business-Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Education Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Dual Degree Program with Dartmouth College",
                    "degree": "B.S.",
                    "note": "Dual degree"
                },
                {
                    "name": "Engineering Dual Degree Program with Rensselaer Polytechnic Institute",
                    "degree": "B.S.",
                    "note": "Dual degree"
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Gender Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geosciences",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "Health and Human Physiological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "International Affairs",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science-French",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science-German",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science-Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Self-Determined Major",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theater",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
